export default "__VITE_ASSET__B04_EMiP__"